function Help() {
    return (
        <section className='help'>
            <div className='abs'>help</div>
        </section>
    )
}

export default Help
